/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServizioMensaEventoCalendarioStatus } from './servizio-mensa-evento-calendario-status';
import { ServizioMensaEventoCalendarioType } from './servizio-mensa-evento-calendario-type';


export interface ServizioMensaEventoCalendarioDTO { 
    id?: string;
    data?: string;
    tipo?: ServizioMensaEventoCalendarioType;
    stato?: ServizioMensaEventoCalendarioStatus;
    descrizione?: string;
}



